/**
 * Checks if a link matches any of the selected filters
 * @param {Object} link - Link object that may contain a filters property
 * @param {Array} selectedFilters - Array of selected filter strings
 * @returns {boolean} True if the link matches at least one selected filter
 */
export const linkMatchesFilters = (link, selectedFilters) => {
  if (!link.filters || link.filters.length === 0) return false;

  return selectedFilters.some((selectedFilter) => {
    // If it's a GENERAL filter, match any filter from the same top level
    if (selectedFilter.endsWith('_GENERAL')) {
      const topLevel = selectedFilter.replace('_GENERAL', '');
      return link.filters.some((linkFilter) =>
        linkFilter.startsWith(`${topLevel}_`)
      );
    }

    // For specific filters, use exact match
    return link.filters.includes(selectedFilter);
  });
};
